import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UserSelectors } from 'store/user';

export default function useAuthenticatedUsers() {
  const selectedAuthenticatedUser = useSelector(
    UserSelectors.selectAuthenticatedUser,
  );
  const list = useSelector(UserSelectors.selectAuthenticatedUsers);
  const authenticatedUsers = useMemo(() => list, [list]);
  const isLoadingAuthenticatedUsers = useSelector(
    UserSelectors.selectIsLoadingAuthenticatedUsers,
  );

  return {
    selectedAuthenticatedUser,
    authenticatedUsers,
    isLoadingAuthenticatedUsers,
  };
}
